import { h, Host } from "@stencil/core";
/**
 * The `ch-grid-settings` component represents a settings window for a grid component.
 */
export class ChGridSettings {
    constructor() {
        this.grid = undefined;
        this.show = false;
    }
    /**
     * Event emitted when the close button of the settings window is clicked.
     */
    settingsCloseClicked;
    windowClosedHandler(eventInfo) {
        eventInfo.stopPropagation();
        this.show = false;
        this.settingsCloseClicked.emit();
    }
    render() {
        return (h(Host, null, h("ch-window", { modal: true, container: this.grid, caption: "Options", closeText: "Close", closeOnOutsideClick: true, closeOnEscape: true, allowDrag: "header", hidden: !this.show, exportparts: "mask,window,header,caption,close,main,footer" }, h("slot", null))));
    }
    static get is() { return "ch-grid-settings"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-settings.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-settings.css"]
        };
    }
    static get properties() {
        return {
            "grid": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChGridElement",
                    "resolved": "HTMLChGridElement",
                    "references": {
                        "HTMLChGridElement": {
                            "location": "global",
                            "id": "global::HTMLChGridElement"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The `HTMLChGridElement` that the settings window is associated with."
                }
            },
            "show": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Indicates whether the settings window is currently shown or not."
                },
                "attribute": "show",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "settingsCloseClicked",
                "name": "settingsCloseClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the close button of the settings window is clicked."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get listeners() {
        return [{
                "name": "windowClosed",
                "method": "windowClosedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=ch-grid-settings.js.map
